import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <div className="page-header">
        <h1 className="page-title">Reset Password</h1>
      </div>
      <div className="container">
        {sent ? (
          <div className="card" style={{ textAlign: 'center' }}>
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#5A8A60" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ margin: '0 auto 16px', display: 'block' }}>
              <path d="M22 2L11 13"/><path d="M22 2L15 22L11 13L2 9L22 2Z"/>
            </svg>
            <h3 style={{ margin: '0 0 8px', fontFamily: "'Plus Jakarta Sans', sans-serif", color: '#4A2E1F' }}>Check your email</h3>
            <p style={{ color: '#7A5A44', fontSize: '14px', lineHeight: '1.5', margin: '0 0 16px' }}>
              If an account exists with that email, we've sent a reset link. Check your inbox (and spam folder).
            </p>
            <Link to="/login" style={{ color: '#7E8B47', fontWeight: '600', fontSize: '14px' }}>
              Back to Login
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="card">
              <p style={{ color: '#7A5A44', fontSize: '14px', lineHeight: '1.5', margin: '0 0 16px' }}>
                Enter your email and we'll send you a link to reset your password.
              </p>
              <input
                type="email"
                className="input"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
                style={{ marginBottom: '16px' }}
              />
              {error && <p style={{ color: '#B8564A', fontSize: '13px', margin: '0 0 12px' }}>{error}</p>}
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading || !email.trim()}
                style={{ width: '100%' }}
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </div>
            <p style={{ textAlign: 'center', margin: '16px 0', fontSize: '14px' }}>
              <Link to="/login" style={{ color: '#7E8B47', fontWeight: '600' }}>Back to Login</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;
